import React, { useState } from "react";
import MotionHoc from "../../../utils/MotionHoc";
import { Col, Row, Space, Table, Card, Spin, Select, message, Tooltip, Button } from "antd";
import Search from "antd/es/input/Search";
import { SearchOutlined, SaveOutlined, BarcodeOutlined } from "@ant-design/icons";
import axios from "axios";
import ThaiDatePicker from '../../../hook/ThaiDatePickerNew';
import PickData from './modal/PickData';
import CheckCONTNO from './modal/CheckCONTNO';
import dayjs from "dayjs";
import { baseUrlAREA, baseUrlNIKKI, CREATE_DG, HEADERS_BASIC, LOAD_MAIN_DG } from "../../API/apiUrlsNew";

function DemandGuarantorMain() {
  const userCompany = localStorage.getItem("COMPANY_ID");
  const TESTcontractOptions = [
    // { value: "lsfhp", label: "สัญญา 1" },
    { value: "vsfhp", label: "สัญญา 2" },
    { value: "psfhp", label: "สัญญา 3" },
    { value: "rpsl", label: "สัญญา 3(ใหม่)" },
    { value: "sfhp", label: "สัญญา 8" },
  ];

  const currentMonth = dayjs().month();
  const currentYear = dayjs().year();

  const [loading, setLoading] = useState(false);
  const [arrData, setArrData] = useState([]);
  const [arrayTable, setArrayTable] = useState([]);
  const [datePicker, setDatePicker] = useState();
  const [selectedContract, setSelectedContract] = useState();
  const [isModalPickData, setIsModalPickData] = useState(false);
  const [isModalSearch, setIsModalSearch] = useState(false);
  const [dataSearch, setDataSearch] = useState();
  const USERNAME = localStorage.getItem("USERNAME");

  const handleLoad = () => {
    if (selectedContract?.value && datePicker) {
      loadData();
    } else {
      message.error("กรุณาเลือกสัญญาและวันที่ !! ");
    }
  };

  const loadData = () => {
    setLoading(true);

    const payload = {
      date: datePicker,
      // date: datePicker.format("YYYY-MM-DD"),
      type: selectedContract.value,
      company: userCompany,
    };

    axios.post(baseUrlNIKKI + LOAD_MAIN_DG, payload, { headers: HEADERS_BASIC })
      .then((response) => {
        if (response.status === 200) {
          setArrayTable(response.data);
          setArrData(response.data);
        }
      })
      .catch((error) => {
        // 2. จัดการกับข้อผิดพลาด (Error)
        const status = error?.response?.status;
        const serverMsg = error?.response?.data?.message;
        console.error("API error:", status, serverMsg || error.message);

        setArrayTable([]);
        setArrData([]);
        message.error(
          serverMsg || `ไม่สามารถดึงข้อมูลได้ (${status ?? " - "})`
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onSearch = (value) => {
    setDataSearch(value)
    setIsModalSearch(true)
  };

  const insertData = async () => {
    if (!arrData || (Array.isArray(arrData) && arrData.length === 0)) {
      message.error("ไม่มีข้อมูลที่บันทึก");
      return;
    }

    setLoading(true);
    let sendData = {
      contractSchema: selectedContract.value,
      roundDate: datePicker,
      demandGuarantor: arrayTable,
      user: USERNAME
    }

    await axios.post(baseUrlAREA + CREATE_DG, sendData, { headers: HEADERS_BASIC })
      .then((res) => {
        if (res.status === 200) {
          message.success("สร้างข้อมูลใหม่สำเร็จ");
        }
      })
      .catch((error) => {
        // 5. จัดการเมื่อ Error
        const status = error?.response?.status;
        const serverMsg =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error.message;

        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`
        );

        console.error("insertData error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const loadDataExport = async (status) => {
  //   if (!arrData || arrData.length < 1) {
  //     message.error("ไม่พบข้อมูล");
  //     return;
  //   }
  //   if (!selectedContract) {
  //     message.error("กรุณาเลือกประเภทสัญญา");
  //     return;
  //   }

  //   setLoading(true);
  //   // const contractNumbers = arrayTable.map((item) => item.CONTNO);

  //   // const sendData = {
  //   //   contractNo: contractNumbers, // นำ Array ที่ได้มาใส่ในคีย์ contractNo
  //   // };
  //   const sendData = {
  //     date: datePicker,
  //     contractSchema: selectedContract.value,
  //   };

  //   await axios.post(baseUrlAREA + LOAD_DG, sendData, { headers: HEADERS_EXPORT_BEN, })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         // if (status === "export") {
  //         //   ExportExcelForUpdatePostNumberDG(res.data, selectedContract);
  //         //   message.success("โหลด Excel สำเร็จ");
  //         // } else {
  //         // setDataAddBarCode(res.data);
  //         // setIsModalAddBarcode(true);
  //         // }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("insertData error:", error);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  const handleAddBarcode = () => {
    setIsModalPickData(true)
  };

  const columns = [
    {
      title: "ลำดับ",
      key: "key",
      align: "center",
      render: (_, record) => <>{record.key}</>,
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "CUSTOMER",
      key: "CUSTOMER",
      align: "center",
      render: (_, record) => (
        <>
          {record.SNAM} {record.NAME1} {record.NAME2}{" "}
        </>
      ),
    },
    {
      title: "ประเภทลูกค้า",
      align: "center",
      render: (_, record) => <>{`ผู้ค้ำที่ ${record.GARNO}`}</>,
    },
    {
      title: "ค้างงวด(จริง)",
      dataIndex: "HLDNO",
      key: "HLDNO",
      align: "center",
    },
    {
      title: "ค้างชำระ (วัน)",
      dataIndex: "DPD_DAYS",
      key: "DPD_DAYS",
      align: "center",
    },
  ];


  const onChangeContract = (value) => {
    setSelectedContract(value)
    setArrData([])
    setArrayTable([])
  }

  const onChangeDatePicker = (value) => {
    setDatePicker(value)
    setArrData([])
    setArrayTable([])
  }

  return (
    <>
      <Card>
        <Row>
          <Col span={12} style={{ textAlign: "start" }}>
            <Space>
              <Select
                key={userCompany}
                size="large"
                style={{ minWidth: "auto" }}
                placeholder="เลือกสัญญา"
                popupMatchSelectWidth={false}
                labelInValue // ★ เปิดใช้
                value={selectedContract} // ต้องเป็น object { value, label }
                // onChange={(obj) => setSelectedContract(obj ?? null)} // obj = { value, label }
                onChange={(obj) => onChangeContract(obj ?? null)} // obj = { value, label }
                options={TESTcontractOptions}
                allowClear
                showSearch
                optionFilterProp="label"
              />

              <ThaiDatePicker
                value={datePicker}
                onChange={onChangeDatePicker}
                // onChange={setDatePicker}
                size="large"
                disabledDate={(current) => {
                  if (!current) return false;

                  // ❌ ไม่ใช่เดือนปัจจุบัน -> disable
                  if (
                    current.month() !== currentMonth ||
                    current.year() !== currentYear
                  ) {
                    return true;
                  }

                  // ❌ ไม่ใช่วันที่ 12 และ 26 -> disable
                  return current.date() !== 12 && current.date() !== 26;
                }}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                size="large"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  background: "linear-gradient(135deg, #667eea, blue)",
                  border: "none",
                }}
                onClick={handleLoad}
                disabled={loading}
              >
                ค้นหา
              </Button>
            </Space>
          </Col>
          <Col span={12} style={{ textAlign: "end" }}>
            <Search
              placeholder="ค้นหาสัญญา"
              enterButton
              onSearch={onSearch}
              style={{
                width: "auto",
                borderRadius: "8px",
              }}
              size="large"
            />
          </Col>
          <Col span={12} style={{ textAlign: "start", marginTop: "5px" }}>
            <Space>
              <Tooltip placement="bottom" title={arrData.length > 0 ? null : "โปรดเลือกประเภทข้อมูลก่อน !"} disabled={true}>
                <Button
                  type="primary"
                  icon={<SaveOutlined style={{ fontSize: "24px", color: "white" }} />}
                  onClick={insertData}
                  disabled={arrData.length === 0 || loading}
                >
                  บันทึก
                </Button>
              </Tooltip>
              {/* <Tooltip placement="bottom" title="ต้องบันทึกก่อนดำเนินการ">
                  <Button
                    type="text"
                    icon={
                      <PrinterOutlined
                        style={{
                          fontSize: "24px",
                          color: arrData.length === 0 ? "grey" : "green",
                        }}
                      />
                    }
                    onClick={() => loadDataExport("export")}
                    disabled={checkSave || loading}
                    style={{
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                    loading={loading}
                  >
                    Export Excel
                  </Button>
                </Tooltip>
                <Tooltip placement="bottom" title="ต้องบันทึกก่อนดำเนินการ">
                  {selectedContract?.value === "lsfhp" ? (
                    <Button disabled> บัญชี 1 ไม่สามารถดำเนินการได้</Button>
                  ) : checkSave ? (
                    <Button disabled>พิมพ์ PDF</Button>
                  ) : (
                    <PrintPDF
                      dataTabelB={arrayTable}
                      selectedContract={selectedContract}
                      printingAll={printingAll}
                      setPrintingAll={setPrintingAll}
                      dataRound={datePicker}
                    />
                  )}
                </Tooltip>
                <Tooltip placement="bottom" title="ต้องบันทึกก่อนดำเนินการ">
                  {selectedContract?.value === "lsfhp" ? (
                    <Button disabled> บัญชี 1 ไม่สามารถดำเนินการได้</Button>
                  ) : checkSave ? (
                    <Button disabled>พิมพ์ที่อยู่ PDF</Button>
                  ) : (
                    <PrintPDFAddress dataTabelB={arrayTable} />
                  )}
                </Tooltip>
                <Tooltip placement="bottom" title="ต้องบันทึกก่อนดำเนินการ">
                  <Button
                    type="text"
                    onClick={() => loadDataExport("barcode")}
                    disabled={checkSave || loading}
                    // disabled={arrData.length === 0 || loading}
                    style={{
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                    loading={loading}
                  >
                    🧾 ยิง Barcode
                  </Button>
                </Tooltip> */}
            </Space>
          </Col>
          <Col span={12} style={{ textAlign: "end", marginTop: "5px" }}>
            <Button
              type="primary"
              danger
              icon={<BarcodeOutlined style={{ fontSize: "24px", color: "white" }} />}
              onClick={handleAddBarcode}
              disabled={loading}
              loading={loading}
            >
              นำเข้าเลขไปรษณีย์
            </Button>
          </Col>
        </Row >
      </Card >
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            <Col span={"24"}>
              <Table
                style={{ marginTop: "10px" }}
                size="small"
                columns={columns}
                dataSource={arrayTable}
                scroll={{ x: 850 }}
                footer={() => (
                  <p>จำนวนสัญญาที่ค้นหาทั้งหมด {arrayTable?.length} </p>
                )}
              />
            </Col>
          </Row>
          {isModalPickData ?
            <PickData
              open={isModalPickData}
              close={setIsModalPickData}
              date={datePicker}
              contractSchema={selectedContract}
            // getData={dataAddBarcode}
            // typeContract={selectedContract}
            />
            : null}

          {/* {isModalAddBarcode ?
        <AddBarcode2
          open={isModalAddBarcode}
          close={setIsModalAddBarcode}
          data={dataAddBarcode}
          typePay={selectedGCode}
          typeContract={selectedContract}
        />
              : null} */}
        </Spin>
      </Card>
      {isModalSearch ?
        <CheckCONTNO
          open={isModalSearch}
          close={setIsModalSearch}
          data={dataSearch}
        />
        : null}

    </>
  );
}

// export default DemandGuarantorMain

const DemandGuarantorMains = MotionHoc(DemandGuarantorMain);
export default DemandGuarantorMains;
